var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"secondary","variant":"tonal"},on:{"click":_vm.handleClick}},[_vm._v("再次下訂")])}
var staticRenderFns = []

export { render, staticRenderFns }